<template>  
	<div>
		<div class="dataTable-headre  d-flex align-items-center justify-content-between mb-3">
			<div class="rightSearch d-flex align-items-center justify-content-between">
				<!---------------------show-record-filter------------------------------>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown w-150 mb-0">
					<select class="float-field form-control" @change="pageLimitFunc()" v-model="pageLimit" v-if="pageLimitFilter != 'disable'">
						<option value="15">15</option>
						<option value="30">30</option>
						<option value="50">50</option>
					</select>
			    </div>
				<!--------------search------------------------------------------------->
				<div class="form-group parentClass has-search mx-2 mb-0 position-relative" v-if="searchFilter != 'disable'" >
					<input type="text" class="form-control" placeholder="search here" v-model="search" @keyup.enter="searchFunc()">
					<feather type="search" class="form-control-feedback text-right" @click="searchFunc()"></feather>
				</div>
				<!--------------manager-list----------------------->
				<div class="d-flex align-items-center" v-if="listStatusFilter == 'ADMIN-LISTING'">
					<div class="userSelect bottomFix" >
						<div class="acceptHold inlineList">
							<router-link  :to="'/create-admin'"  class="grd_btn btn-sm d-flex align-items-center">
							<feather type="plus" class="mr-2 customSize"></feather>Create Manager</router-link>  
						</div> 
					</div>
					
				</div>
				<!--------------client-list----------------------->
				<div class="d-flex align-items-center" v-if="listStatusFilter == 'CLIENT-LISTING'">
					<div class="userSelect bottomFix" >
						<div class="acceptHold inlineList">
							<router-link  :to="'/create-client'"  class="grd_btn btn-sm d-flex align-items-center">
							<feather type="plus" class="mr-2 customSize"></feather>Create Client</router-link>  
						</div>
					</div>
					
				</div>
				<!--------------deposit list ---------------->
				<div class="d-flex align-items-center" v-if="listStatusFilter == 'DEPOSIT-LISTING'">
					<div class="userSelect bottomFix" v-if="showCreate == 'yes'">
						<div class="acceptHold inlineList">
							<router-link  :to="{name: 'shared.search' , query: { 'page':'deposit'}}" class="grd_btn btn-sm d-flex align-items-center">
							<feather type="plus" class="mr-2 customSize"></feather>Create Deposit</router-link>  
						</div>
					</div>
					
				</div>
				<!--------------Bonus  Listing---------------->
				<div class="d-flex align-items-center" v-if="listStatusFilter == 'BONUS-LISTING'">
					<div class="userSelect bottomFix" v-if="showCreate == 'yes'">
						<div class="acceptHold inlineList">
							<router-link  :to="{name: 'shared.search' , query: { 'page':'bonus'}}"  class="grd_btn btn-sm d-flex align-items-center">
							<feather type="plus" class="mr-2 customSize"></feather>Create Bonus</router-link>  
						</div>
					</div>
					
				</div>
				<!-----------create deposit,ticket,trading-account,withdrawal----------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'CREATE-DEPOSIT' || listStatusFilter == 'CREATE-TICKET' || listStatusFilter == 'CREATE-TRADING-ACCOUNT' || listStatusFilter == 'CREATE-WITHDRAWAL' || listStatusFilter == 'CREATE-BONUS' || listStatusFilter == 'EDIT-COMMISSION'">{{page}}
					<div class="acceptHold inlineList" v-if="$parent.page == 'search'">
						<router-link  :to="{name: $parent.path}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to {{$parent.pageName}}</router-link>  
					</div>
					<div class="acceptHold inlineList" v-else>
						<router-link  :to="{name: $parent.path , query: {'id':$parent.user_id}}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to {{$parent.pageName}}</router-link>  
					</div>
				</div>
				<!---------------------search page--------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'SEARCH-LIST'">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: $parent.listPath}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to {{$parent.pageName}} list</router-link>  
					</div>
				</div>
				<!--------------------trading-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'TRADING-ACCOUNTS-LISTING' && showCreate == 'yes'">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'trading'}}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Trading Account</router-link>  
					</div>
				</div>
				
				<!--------------------withdrawal-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'WITHDRAWAL-LISTING' && showCreate == 'yes'">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'withdrawal'}}" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Withdrawal</router-link>  
					</div>
				</div>
				<!--------------------ticket-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'TICKET-LISTING' && showCreate == 'yes'">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'ticket'}}" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Ticket</router-link>  
					</div>
				</div>

				<div class="d-flex align-items-center" v-if="listStatusFilter == 'NOTIFICATION-LISTING'">
					<select class="float-field form-control" @change="notificationFunc()" v-model="notification">
						<option value="">New Registration</option>
						<option value="VERIFY_ACC">Verify Account</option>
						<option value="WITHDRAWAL">Withdrawl</option>
						<option value="BONUS">Bonus</option>
						<option value="CLIENT_ADD_DOC">Client Additional Documents</option>
						<option value="CREDIT_CARD_NOTIFICATION">Credit Card Details</option>
						<!-- <option value="IBREG_NOTIFICATION">Franchisee Registration</option>
						<option value="IBDOC_NOTIFICATION">Franchisee Documents Upload</option>
						<option value="IBADD_DOC_NOTIFICATION">Franchisee Additonal Documents</option> -->
					</select>
				</div>
				
				<div class="d-flex align-items-center" v-if="listStatusFilter == 'ADMIN-LISTING'">
					<select class="float-field form-control" @change="adminRoles()" v-model="roles">
						<option value="">Select Roles</option>
						<option value="AC">Accounts</option>
						<option value="SL">Sales</option>
						<option value="BO">Back Office</option>
						<option value="CS">Customer Spport</option>
						<option value="RM">Reporting Manager</option>
					</select>
				</div>
			</div> 
		</div>
		
		
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'TRADING-ACCOUNTS-LISTING'">
			<li><a :class="($parent.demo_live == '0')?'active' : ''" href="#" @click="showAccountList('0')"><span></span>Demo Accounts</a></li>
			<li><a  :class="($parent.demo_live == '1')?'active' : ''" href="#" @click="showAccountList('1')"><span></span>Live Accounts</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'WITHDRAWAL-LISTING'">
			<li><a :class="($parent.listStatus == '')?'active' : ''" href="#" @click="withdrawalFilter('')"><span></span>All</a></li>
			<li><a :class="($parent.listStatus == 'approved')?'active' : ''" href="#" @click="withdrawalFilter('approved')"><span></span>Approved</a></li>
			<li><a  :class="($parent.listStatus == 'denied')?'active' : ''" href="#" @click="withdrawalFilter('denied')"><span></span>Denied</a></li>
			<li><a  :class="($parent.listStatus == 'pending')?'active' : ''" href="#" @click="withdrawalFilter('pending')"><span></span>Pending</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'TICKET-LISTING'">
			<li><a :class="($parent.ticket_status == '0')?'active' : ''" href="#" @click="ticketStatusList('0')"><span></span>Open</a></li>
			<li><a  :class="($parent.ticket_status == '3')?'active' : ''" href="#" @click="ticketStatusList('3')"><span></span>Close</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'DEPOSIT-LISTING'">
			<li><a :class="($parent.listStatus == '')?'active' : ''" href="#" @click="depositFilter('')"><span></span>All</a></li>
			<li><a  :class="($parent.listStatus == 'approved')?'active' : ''" href="#" @click="depositFilter('approved')"><span></span>Approved</a></li>
			<li><a :class="($parent.listStatus == 'denied')?'active' : ''" href="#" @click="depositFilter('denied')"><span></span>Denied</a></li>
			<li><a :class="($parent.listStatus == 'internal')?'active' : ''" href="#" @click="depositFilter('internal')"><span></span>Internal Transfer</a></li>
		</ul>
	</div>
</template>
<script>   
	import { fxViewMixins } from '@/plugins/fxView'
	import moment from 'moment'
	import DatePicker1 from 'vue2-datepicker'
	export default{
	  name: 'FILTERS',
	  mixins: [fxViewMixins],
	  data(){
		return { 
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
				monthBeforeYear: false,
			},
			toDateField : '',
			fromDateField : '',
			//=======================logs===============================
			startdates : moment().format("MM-YYYY") ,
			//=========================================================
			search : '',
			page:'',
			pageLimit : '15',
			delayTimer : null,
			//======================ticket-list==========================
			listStatus : '',
			ticket_Filter : '',
			read_ticket : '',
			//======================deposit-list==========================
			depositMode : '',
			notification : '',
			roles : ''
		}
	  },
	  components: {
			DatePicker1
        },
	  props:['pageLimitFilter','searchFilter','listStatusFilter','showCreate'],
	  methods:{
		dateFormat(date){
			return moment(date).format('YYYY-DD-MM')
		},
		notificationFunc(){
			this.$parent.notificationType = this.notification
			this.$parent.listing()
		},
		adminRoles(){
			this.$parent.roles = this.roles
			this.$parent.listing()
		},
		//======================logs=================================
		dateFocus(){
			if(this.startdates != null){
				this.$parent.startdates =  moment(this.startdates).format("MM-YYYY")
				this.$parent.listing()
			}else{
				this.startdates =  ''
				this.$parent.startdates =  ''
				this.$parent.listing()
			}
		},
		//======================ticket-list==========================
		listStatusFunc(){
			this.$parent.page = '1'
			this.$parent.listStatus = this.listStatus
			this.$parent.listing()
		},
		ticketFilterFunc(){
			this.$parent.ticket_Filter = this.ticket_Filter
			this.resetdata()
		},
		ticketStatusList(getData){
			this.$parent.ticket_status = getData
			this.resetdata()
		},
		//======================deposit-list==========================
		depositModeFunc(){
			this.$parent.page = '1'
			this.$parent.depositMode = this.depositMode
			this.$parent.listing()
		},
		depositFilter(getData){
			this.$parent.listStatus = getData
			this.resetdata()
		},
		//=====================withdrawal-list=======================
		withdrawalFilter(getData){
			this.$parent.listStatus = getData
			this.resetdata()
		},
		//=====================trading-list==========================
		showAccountList(getData){
			this.$parent.demo_live = getData
			this.resetdata()
		},
		//=====================reporting=============================
		reportStatusList(getData){
			this.$parent.report_status = getData
			this.resetdata()
		},
		//=====================common=================================
		resetdata(){
			this.$parent.page = '1'
			this.$parent.search = ''
			this.$parent.pageLimit = '15'
			this.search = this.$parent.search
			this.pageLimit = this.$parent.pageLimit
			this.$parent.listing()
		},
		pageLimitFunc(){
			this.$parent.pageLimit = this.pageLimit
			this.$parent.listing()
		},
		searchFunc(){
			this.$parent.page = '1'
			this.$parent.search = this.search
			this.$parent.listing()
			
		}
	  }
	}
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/top_header_title.vue